import { render, staticRenderFns } from "./CarbonOffset.vue?vue&type=template&id=288962c1&scoped=true"
import script from "./CarbonOffset.vue?vue&type=script&lang=js"
export * from "./CarbonOffset.vue?vue&type=script&lang=js"
import style0 from "./CarbonOffset.vue?vue&type=style&index=0&id=288962c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288962c1",
  null
  
)

export default component.exports